import React from "react"
import { Box, Typography } from "@mui/material"
import { ButtonIconSeeker } from "@ui-seeker/core"
import { truncateString } from "@utils"
import { dsColorNew } from "@palette"


export default function nameColumn() {
	return {
		name: "file_name", label: "File Name",
		options: {
			customBodyRowRenderLite: (value, row) => <Box
				sx={{ textAlign: 'center', display: "flex", justifyContent: "center" }}>
				<Typography sx={{ p: 1 }}>{truncateString(value || "", 35)}</Typography>

				{row.export_url && <ButtonIconSeeker
					icon="file-download"
					tooltip="Download raw batch file"
					onClick={e => {
						window.open(row.export_url)
						if (e.ctrlKey) e.preventDefault()
					}}
					onAuxClick={e => {
						if (e.button === 1) {
							window.open(row.export_url)
							e.preventDefault()
						}
					}}
					sx={{ color: dsColorNew.appBlue }}
				/>}
			</Box>
		}
	}
}